import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components'
import { Home, News, NewsArticle, Rules, Vote, Store, Staff } from './pages'
import './styles/global.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="news" element={<News />} />
        <Route path="news/:articleId" element={<NewsArticle />} />
        <Route path="rules" element={<Rules />} />
        <Route path="vote" element={<Vote />} />
        <Route path="store" element={<Store />} />
        <Route path="staff" element={<Staff />} />
      </Route>
    </Routes>
  );
}

export default App;
